import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Box,
  Text,
  VStack,
  Divider,
} from "@chakra-ui/react";

import InformativeVerticalProgress from "./InformativeVerticalProgress";
import { buildTimeline } from "../../helpers/timeline";

export default function CategoryDetailDialog({
  isOpen,
  onClose,
  data,
}) {
  if (!data) return null;

  const timelineSteps = buildTimeline(data.comments);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Ticket Detail</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack align="stretch" spacing={4}>
            {/* BASIC INFO */}
            <Box>
              <Text fontWeight="bold">Subject</Text>
              <Text>{data.subject}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold">Description</Text>
              <Text>{data.description}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold">Category</Text>
              <Text>{data.category?.name}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold">Assigned To</Text>
              <Text>{data.assigned_user?.name ?? "-"}</Text>
            </Box>

            <Divider />

            {/* PROGRESS + ACTIVITY */}
            <Box>
              <Text fontWeight="bold" mb={4}>
                Progress & Activity
              </Text>

              <InformativeVerticalProgress steps={timelineSteps} />
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
